import * as React from "react";
import Icon from "~/components/icons/icon";
import classNames from "classnames";
import ShowMore from "~/components/show-more/show-more";

export interface ProductReviewItemProps {
    item: {
        review?: string;
        source?: string;
        rating?: number;
        ratingRange?: number;
        ratingLabel?: string;
    };
    labels: {
        showMore: string;
        showLess: string;
    };
}

const ProductReviewItem: React.FC<ProductReviewItemProps> = ({ item, labels }) => {
    const baseClass = "product-review-item";
    const reviewSectionRef = React.useRef<HTMLDivElement>(null);

    const getVisualRatingIcons = () => {
        if (!item.rating) {
            return;
        }

        const ratingIconList = [];
        const range = item.ratingRange || 6;

        for (let i = 0; i < range; i++) {
            const isCurrentIconInactive = i >= item.rating;

            const iconClasses = classNames(`${baseClass}__rating-icon`, {
                [`${baseClass}__rating-icon--is-inactive`]: isCurrentIconInactive
            });

            ratingIconList.push(<Icon iconId="24_star" className={iconClasses} key={i} />);
        }

        return ratingIconList;
    };

    const showMoreMinHeight = 300;
    const ratingSectionHeight = 74;

    const showMoreMinHeightWithoutRatingSection = showMoreMinHeight + ratingSectionHeight;

    return (
        <div className={baseClass}>
            <div className={`${baseClass}__content`}>
                {item.source && (
                    <div
                        className={`${baseClass}__source`}
                        dangerouslySetInnerHTML={{ __html: item.source }}
                    />
                )}
                <div className={`${baseClass}__rating-section`}>
                    {!!item.rating && (
                        <>
                            <div className={`${baseClass}__rating`}>{getVisualRatingIcons()}</div>
                            {item.ratingLabel && (
                                <div className={`${baseClass}__rating-label`}>{item.ratingLabel}</div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <ShowMore
                minHeight={!item.rating ? showMoreMinHeightWithoutRatingSection : showMoreMinHeight}
                className={`${baseClass}__expand-btn`}
                btnLabelShowLess={labels.showLess}
                btnLabelShowMore={labels.showMore}
            >
                <div
                    ref={reviewSectionRef}
                    className={`${baseClass}__review-section`}
                    dangerouslySetInnerHTML={{ __html: item.review ?? "" }}
                />
            </ShowMore>
        </div>
    );
};

export default ProductReviewItem;
